import React, { useState, useEffect } from 'react';
/* eslint-disable */
import * as Yup from 'yup';
// material
import { Container, Grid, } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, InputAdornment, Button, } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import { makeStyles } from '@material-ui/styles';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import Services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import { AESDecryptionParam } from '../../../../helpers/AesEncrypt';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const useStyles = makeStyles({
  table: {
    minWidth: 700
  }
});

var screenCode = "GRADEMASTER"
export default function GradeMasterAddEdit(props) {
  const [date, setDate] = useState(new Date());
  const [value, setValue] = useState(null);
  const [idValue, setIDvalue] = useState(0);
  const [groupList, setGroupList] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    groupID: 0,
    GradeCode: '',
    GradeName: '',
    Description: '',

    isActive: true,
  });
  const [pageProps, setPageProps] = useState({
    isEdit: false,
    editingID: 0,
    isEdit: false,
    submitButtonName: "Save",
    pageName: "Add Grades"
  });

  const productcatogerySearchSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
    GradeName: Yup.string().min(1, 'GradeName is required').required('GradeName is required'),
    GradeCode: pageProps.isEdit == false
      ? Yup.string().required('GradeCode required')
      : Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      GradeCode: formData.GradeCode,
      GradeName: formData.GradeName,
      Description: formData.Description,
      isActive: formData.isActive,
    },

    validationSchema: productcatogerySearchSchema,
    onSubmit: (values) => {
      trackPromise(SubmitForm(values));
    }
  });

  const { gradeID } = useParams();
  let decrypted = 0;

  useEffect(() => {
    decrypted = AESDecryptionParam(gradeID);
    if (decrypted != 0) {
      setPageProps({
        ...pageProps,
        isEdit: true,
        submitButtonName: "Update",
        editingID: parseInt(decrypted),
        pageName: "Edit Grades"
      })
      setIDvalue(decrypted);
      trackPromise(GetGradeDetailsByGroupID(decrypted))
    }

    getPermissions();
  }, []);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITGRADEMASTER');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });
    trackPromise(GetAllGroups());

    setValues({
      ...values,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
      operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
    })

  }

  async function GetAllGroups() {
    var res = await Services.GetAllGroupsForDropDown();
    if (res != null) {
      setGroupList(res);
    }
  }

  async function GetGradeDetailsByGroupID(gradeID) {
    var res = await Services.GetGradeDetailsByGroupID(gradeID);
    if (res != null) {
      setValues({
        ...values,
        groupID: res[0].groupID,
        GradeCode: res[0].gradeCode,
        GradeName: res[0].gradeName,
        Description: res[0].gradeDescription,
        IsActive: res[0].IsActive,
      })
    }
  }

  async function SubmitForm(data) {
    if (pageProps.isEdit == false) {
      let saveModel = {
        gradeID: 0,
        groupID: data.groupID,
        gradeCode: data.GradeCode,
        gradeName: data.GradeName,
        gradeDescription: data.Description,
        isActive: data.isActive,
        createdBy: parseInt(TokenDecoder.getUserIDFromToken())
      }
      var res = await Services.SaveGrade(saveModel)
      if (res.statusCode === "Success") {
        toast.success(res.message);
        setTimeout(() => {
          navigate('/dashboard/GradeMaster');
        }, 3000);
      } else {
        toast.error(res.message);
      }
    }
    else {
      let saveModel = {
        gradeID: parseInt(idValue),
        groupID: data.groupID,
        gradeCode: data.GradeCode,
        gradeName: data.GradeName,
        gradeDescription: data.Description,
        isActive: data.isActive,
        createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
        modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
      }
      var res = await Services.UpdateGrade(saveModel)
      if (res.statusCode === "Success") {
        toast.success(res.message);
        setTimeout(() => {
          navigate('/dashboard/GradeMaster');
        }, 3000);
      } else {
        toast.error(res.message);
      }
    }
  }

  async function clearAll() {
    setValues({
      ...values,
      groupID: 0,
      GradeID: 0,
      GradeCode: '0',
      GradeName: '',
      Description: 0,
      isActive: true,
    })
  }
  const { errors, touched, setValues, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  return (
    <>
      <LoadingComponent />
      <Page title="Add Grades |  FAPS">
        <Container>
          <CommonPageHeader
            path={'/dashboard/GradeMaster'}
            btname="Back"
            pageName={pageProps.pageName}
          />

          <FormikProvider value={formik}>
            <ToastContainer position="bottom-right" pauseOnHover />
            <Form
              autoComplete="off"
              disabled={!(formik.isValid && formik.dirty)}
              noValidate
              onSubmit={handleSubmit}
            >
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    value={formik.values.groupID}
                    onChange={formik.handleChange}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    inputProps={{
                      readOnly: pageProps.isEdit
                    }}
                  >
                    <MenuItem key={0} value={0}>Select Group</MenuItem>
                    {groupList.map((option) => (
                      option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                        {option.groupName}
                      </MenuItem> : null
                    ))}
                  </TextField>


                  <TextField
                    fullWidth
                    size="small"
                    label="Grade Code *"
                    value={formik.values.GradeCode}
                    onChange={formik.handleChange}
                    {...getFieldProps('GradeCode')}
                    inputProps={{
                      readOnly: pageProps.isEdit
                    }}

                    error={Boolean(touched.GradeCode && errors.GradeCode)}
                    helperText={touched.GradeCode && errors.GradeCode}
                  />

                  <TextField
                    fullWidth
                    size="small"
                    label="Grade Name *"
                    value={formik.values.GradeName}
                    onChange={formik.handleChange}
                    {...getFieldProps('GradeName')}
                    error={Boolean(touched.GradeName && errors.GradeName)}
                    helperText={touched.GradeName && errors.GradeName}
                  />

                  <TextField
                    fullWidth
                    size="small"
                    label="Description "
                    value={formik.values.Description}
                    onChange={formik.handleChange}
                    {...getFieldProps('Description')}
                    error={Boolean(touched.Description && errors.Description)}
                    helperText={touched.Description && errors.Description}
                  />

                </Stack>
              </Stack>
              <br />
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <FormControlLabel
                  control={
                    <Switch
                      value={formik.values.isActive}
                      checked={formik.values.isActive}
                      {...getFieldProps('isActive')}
                      onClick={formik.handleChange}
                      color="error"
                      name="isActive"
                      inputProps={{ 'aria-label': 'primary checkbox' }}
                    />}
                  label="Is Active"
                />
              </Stack>
              <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                <Button
                  type="button"
                  color='error'
                  variant="outlined"
                  disabled={pageProps.editingID > 0}
                  onClick={() => clearAll()}
                > Clear</Button>

                <Button type="submit" color="secondary" variant="outlined">
                  {pageProps.submitButtonName}
                </Button>
              </Stack>
            </Form>
          </FormikProvider>
        </Container>
      </Page>
    </>
  );
}
